const RevenueShareOfferingStatusTypeName = "RevenueShareOfferingStatus";
const UpdateAffiliateBtagModelTypeName = "UpdateAffiliateBtagModel";
const getBtagRegex = () => new RegExp("^((a|A)_(\\d+)(b|B)_(\\d+)((c|C)_([a-zA-Z0-9_-]*))?)$");
export {
  RevenueShareOfferingStatusTypeName,
  UpdateAffiliateBtagModelTypeName,
  getBtagRegex
};
//# sourceMappingURL=constants.js.map
